export default {
  model () {
    return {
      name: '',
      startDate: '',
      endDate: '',
      $dateRange: ''
    }
  },
  rules: {
    name: {required: true, message: 'El nombre es requerido'},
    startDate: {required: true, message: 'La fecha inicial es requerida'},
    endDate: {required: true, message: 'La fecha final es requerida'},
    $dateRange: {required: true, message: 'El periodo es requerido'}
  }
}



// WEBPACK FOOTER //
// ./src/modules/periods/period.model.js